import { UserSessionResponseInterface } from 'src/interfaces/interfaces';

import { CreditCardInterface } from './interfaces/credit-card.interface';
import { IExtraPaymentFields } from './interfaces/payment.interface';

export interface IGeneratePaymentMethod {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
  credit_card: Partial<CreditCardInterface> & IExtraPaymentFields;
  email: string;
  allow_blank_name: boolean;
}

export const getCardName = (credit_card: CreditCardInterface, user: UserSessionResponseInterface | null) => {
  let cardName = '';
  try {
    cardName = (credit_card.first_name || credit_card.last_name).replace(/[^a-zA-Z]/g, '');
    cardName = nameFromUser(user);
  } catch (e) {
    cardName = 'NODATANAME';
  }

  return cardName;
};

export const maskCreditCard = (number: string = '') => {
  const reg = /(?!\b.{4}[ -])(?:[ -]?\d{4}[ -]?){2}(?=\d{4}\b)/;
  return number.replace(reg, '********');
};

export const nameFromUser = (user: UserSessionResponseInterface | null): string => {
  const mailUsername = user?.email.match(/^[^@]+/g);
  let name = '';
  try {
    if (!name) {
      name =
        (user?.first_name ? user.first_name.replace(/[^a-zA-Z]/g, '') : '') ||
        (mailUsername ? mailUsername[0].replace(/[^a-zA-Z]/g, '') : 'NODATANAME');
    }
  } catch (e) {
    name = 'NODATANAME';
  }

  if (name.length === 0) {
    name = 'NODATANAME';
  }

  return name;
};

// *DONT FORGET TO ENCRYPT/MASK/REPLACE ANY FIELD THAT IS SENSITIVE IF NECESARY,
// *YOU CAN USE REPLACEFIELDS TO REPLACE THE FIELD WITH THE ENCRYPTED VALUE
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generatePaymentMethod = (config: IGeneratePaymentMethod): { payment_method: IGeneratePaymentMethod } => ({
  payment_method: config,
});
